module.exports = __webpack_public_path__ + "static/img/zyk_app.7797c2fe.jpg";